module.exports = __webpack_public_path__ + "static/img/bg-bottom.44269f4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/login/bg-bottom.png
// module id = XvNN
// module chunks = 1